import {Component, OnInit} from '@angular/core';
import {Location} from '@angular/common';
import {Observable} from "rxjs";
import {
  FrequentlyAskedQuestion
} from "../../../store/entities/frequently-asked-question/frequently-asked-question.model";
import {
  FrequentlyAskedQuestionActions
} from "../../../store/entities/frequently-asked-question/frequently-asked-question.actions";
import {
  FrequentlyAskedQuestionFeature
} from "../../../store/entities/frequently-asked-question/frequently-asked-question.reducer";
import {Store} from "@ngrx/store";
import {AppState} from "../../../store/reducers";

@Component({
  selector: 'app-frequently-asked-question',
  templateUrl: './frequently-asked-question.component.html',
  styleUrls: ['./frequently-asked-question.component.scss']
})
export class FrequentlyAskedQuestionComponent implements OnInit {

  frequentlyAskedQuestionsList$!: Observable<FrequentlyAskedQuestion[]>;

  constructor(
    private location: Location,
    private store: Store<AppState>) { }


  ngOnInit() {
    this.store.dispatch(FrequentlyAskedQuestionActions.loadFrequentlyAskedQuestions())
    this.frequentlyAskedQuestionsList$ = this.store.select(FrequentlyAskedQuestionFeature.selectAll)
  }


}
